import { render, staticRenderFns } from "./FamilyCategoryCard.vue?vue&type=template&id=13fd7f99&scoped=true&"
import script from "./FamilyCategoryCard.vue?vue&type=script&lang=js&"
export * from "./FamilyCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./FamilyCategoryCard.vue?vue&type=style&index=0&id=13fd7f99&prod&lang=scss&scoped=true&"
import style1 from "./FamilyCategoryCard.vue?vue&type=style&index=1&id=13fd7f99&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd7f99",
  null
  
)

export default component.exports